<template>
  <div>
    <BaseButton primary outline @click="openDialog"> Add Tags </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$modal.show({
        component: () => import('./AddTagsDialog.vue'),
        props: {
          query: this.query,
          accountId: this.accountId,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
